<template>
  <v-menu
    v-model="open"
    :color="themes.client.light.tooltip"
    class="px-0"
    bottom
    open-on-click
    nudge-bottom="25"
    max-width="300"
  >
    <v-chip small slot="activator" @click.stop="open = !open">
      {{ financial.currency }}
      {{ financial.incomes.map(i => i.grossIncome).reduce((acc, inc) => acc + inc, 0) }}
    </v-chip>
    <v-card :class="themes.client.light.dialogTitle">
      <v-layout row wrap justify-space-between>
        <v-flex xs12 d-flex>
          <v-card-text>Gross monthly income for {{ financial.dependents }} dependents</v-card-text>
          <v-card-actions>
            <CreateFlag
              v-if="!alreadyFlagged"
              :target="{ ...financial, type: 'FinancialSurvey' }"
              :profile="profile"
              :filter="['financial_survey']"
              @done="refresh"
            >
              <v-btn icon flat :color="themes.client.light.cancel" slot="activator">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </CreateFlag>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-card>
  </v-menu>
</template>

<script>
// Components
import CreateFlag from '@/components/client/flags/CreateFlag'

// Helpers
import _ from 'lodash'

export default {
  components: { CreateFlag },

  props: { profile: { type: Object, required: true } },

  data() {
    return {
      open: false,
    }
  },

  computed: {
    alreadyFlagged(qualification) {
      const flags = _.get(this, 'profile.flags')

      if (!flags) return false

      return flags.some(f => {
        return f.targetId === this.financial.id && f.targetType === 'FinancialSurvey'
      })
    },

    financial() {
      if (!this.profile.financial) return

      return this.profile.financial
    },
  },

  methods: {
    refresh() {
      this.$emit('refresh')
      this.open = false
    },
  },
}
</script>
